module.exports = __webpack_public_path__ + "img/image82.cab839a2.png";